import { render, staticRenderFns } from "./management-library-compliance-item-view.vue?vue&type=template&id=fb0ea1dc&"
import script from "./management-library-compliance-item-view.vue?vue&type=script&lang=js&"
export * from "./management-library-compliance-item-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports